import { Injectable } from '@angular/core';
import { Preparable } from '../../lib/helpers/preparable';

@Injectable()
export class CacheService {

    set(key: string, data: any, sensible: boolean = false) {
        const dataString = typeof data === 'string' ? data : JSON.stringify(data);
        // If it is not sensible data, store it with flat key
        if (!sensible) {
            return localStorage.setItem(key, data);
        }
        const sensibleData = localStorage.getItem('sensible');
        // If there is no sensible data yet, we create the object with this new key-value
        if (!sensibleData) {
            const newSensibleObj = {};
            newSensibleObj[key] = data;
            return localStorage.setItem('sensible', JSON.stringify(newSensibleObj));
        }
        // If sensible data already exists, we append this key-value to it
        const sensibleObj = JSON.parse(sensibleData);
        sensibleObj[key] = data;
        return localStorage.setItem('sensible', JSON.stringify(sensibleObj));
    }
    get(key: string) {
        // Try getting the flat key
        const item = localStorage.getItem(key);
        if (item) { return item; }
        // Try getting from sensible data
        const sensibleData = localStorage.getItem('sensible');
        if (!sensibleData) { return null; }
        const sensibleObj = JSON.parse(sensibleData);
        if (!sensibleObj[key]) { return null; }
        return JSON.stringify(sensibleObj[key]);
    }
    delete(key: string) {
        // Try getting the flat key
        const item = localStorage.getItem(key);
        if (item) {
            localStorage.removeItem(key);
            return true;
        }
        // Try getting from sensible data
        const sensibleData = localStorage.getItem('sensible');
        if (!sensibleData) { return false; }
        const sensibleObj = JSON.parse(sensibleData);
        if (!sensibleObj[key]) { return false; }
        delete sensibleObj[key];
        localStorage.setItem('sensible', JSON.stringify(sensibleObj));
        return true;
    }
    clear() {
        return localStorage.clear();
    }
    clearSensible() {
        return localStorage.removeItem('sensible');
    }
}
